/* Centralized API access for CafeVista lead capture.
   Base URL comes from REACT_APP_API_URL (see .env.example).
   Falls back to local Django dev server. */

const RAW = (process.env.REACT_APP_API_URL || "").trim();

/* Resolution order:
   1. REACT_APP_API_URL if it was set at build time.
   2. Production: same-origin "/api" — nginx proxies it to the Django service
      (see nginx.conf.template). No rebuild needed to repoint the backend, and
      no CORS/CSRF cross-origin dance.
   3. Dev: the local Django runserver. */
export const API_BASE = RAW
  ? RAW.replace(/\/+$/, "")
  : process.env.NODE_ENV === "production"
  ? "/api"
  : "http://127.0.0.1:8000/api";

export function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : "";
}

export async function apiPost(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": getCsrfToken(),
    },
    body: JSON.stringify(body),
  });

  let data = null;
  try {
    data = await res.json();
  } catch (_) {
    /* non-JSON or empty response */
  }

  if (!res.ok) {
    const message =
      (data && (data.message || data.error)) || `Request failed (${res.status})`;
    throw new Error(message);
  }
  return data || {};
}

export async function apiGet(path) {
  const res = await fetch(`${API_BASE}${path}`);
  let data = null;
  try {
    data = await res.json();
  } catch (_) {
    /* non-JSON or empty response */
  }
  if (!res.ok) {
    const message =
      (data && (data.message || data.error)) || `Request failed (${res.status})`;
    throw new Error(message);
  }
  return data || {};
}

/* Backend origin without the /api suffix — for non-REST backend routes such as
   the Google OAuth redirect. Same-origin in production; nginx proxies /auth/
   alongside /api/. */
export const BACKEND_ORIGIN = API_BASE.replace(/\/api\/?$/, "");
export const backendUrl = (path) => `${BACKEND_ORIGIN}${path}`;

export const scheduleMeeting = (payload) => apiPost("/schedule-meeting/", payload);
export const subscribeNewsletter = (email) => apiPost("/newsletter/", { email });
export const submitContact = (payload) => apiPost("/contact/", payload);
export const verifyCertificate = (id) => apiGet(`/certificates/${encodeURIComponent(id)}/`);
